/* eslint-disable class-methods-use-this */
/* eslint-disable no-return-assign */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { TextArea, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomTextareaSettingsForm from './CustomTextarea.settingsForm';
import './CustomTextarea.scss';
import getLocalParams from '../localizationCustoms';

const CustomTextarea = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };

    this.setValue = this.setValue.bind(this);
  }

  setValue = (v) => {
    const { onChange, component: { label, reviewLabel, useReviewLabel, charLimit } } = this.props;
    v = useReviewLabel
      ? { value: v, review: { label: reviewLabel, charLimit } }
      : { value: v, review: { label, charLimit } };
    this.setState({ value: v }, () => {
      const { value } = this.state;
      onChange(value);
    });
  };

  render() {
    const { value } = this.state;
    const { component: { label, tooltip, customDescription, hideCustomLabel, characterLimit } } = this.props;
    return (
      <>
        {!hideCustomLabel && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <label className="label-question xs-margin-bottom">
              <FormattedMessage id={label} defaultMessage={label} />
            </label>
            {tooltip !== '' && (
              <Tooltip id="textarea_tooltip" primary>
                <FormattedMessage id={tooltip} defaultMessage={tooltip} />
              </Tooltip>
            )}
          </div>
        )}
        {customDescription && (
          <div className="form-text text-muted small-margin-bottom">
            <FormattedMessage id={customDescription} defaultMessage={customDescription} />
          </div>
        )}
        <TextArea
          value={value && value.value ? value.value : ''}
          onChange={(v) => this.setValue(v)}
          maxLength={+characterLimit}
        />
      </>
    );
  }
};

export default class TextareaComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Textarea',
      icon: 'terminal',
      group: 'basic',
      documentation: '',
      schema: TextareaComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customtextarea',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomTextareaSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  async attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);
    await element.getElementsByTagName('input').value;

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomTextarea
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          data={this.data}
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  async detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
